import AnimationFadeIn from "@components/AnimationFadeIn";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import { Container } from "@mui/material";
import { useEffect, useState } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { TableTabs } from "../../../../../components/TableTabs/Index";
import EditProject from "../DetailsProject/EditProject";
import LearningObjectProject from "../LearningObjectProject";
import ContextProject from "../ContextProject";
import ButtonBackPage from "@components/ButtonBackPage";
import { useLocation } from "react-router-dom";
import CostModelProject from "../CostModelProject";
import HeroProject from "../HeroProject";
import { ServicesURL } from "@utils/utilsApi";
import { useFetchDataDetail } from "@hooks/useFetchDetail";
import { PagesID } from "@utils/utilsConfigurations";
import { useAuth } from "@context/auth";

const DetailProject: React.FC = () => {
  const { t } = useTranslation(["projects-page"]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [newTab, setNewTab] = useState<number | undefined>();
  const location = useLocation();
  const defaultTab = location.state?.tab;
  const { idProject, id } = useParams();
  const { user } = useAuth();

  /*Get the project information*/
  const { dataDetail: dataProject } = useFetchDataDetail(
    `${ServicesURL.getProjects}/${idProject}?corporateId=${id}`,
    PagesID["projects.cost-model"],
  );

  useEffect(() => {
    switch (defaultTab) {
      case "lo":
        setNewTab(2);
        break;
      case "cost-model":
        setNewTab(3);
        break;
      case "detail-cost":
        setNewTab(4);
        break;
    }
  }, [defaultTab]);

  const tabs = [
    {
      [t("tab.details")]: <EditProject />,
    },
    {
      [t("tab.context")]: (
        <ContextProject projectStatus={dataProject?.dto?.status} />
      ),
    },
    {
      [t("tab.learning_object")]: (
        <LearningObjectProject projectStatus={dataProject?.dto?.status} />
      ),
    },
    {
      [t("tab.cost_model")]: (
        <CostModelProject projectStatus={dataProject?.dto?.status} />
      ),
    },
  ];

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-project.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth="xxl"
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroProject />

        <ButtonBackPage />
        <TableTabs
          setExternalSelectedTab={setSelectedTab}
          tabs={tabs}
          goToTab={newTab}
        />
      </Container>
    </AnimationFadeIn>
  );
};

export default DetailProject;
